import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { userKeys } from '@/lib/query/keys/user';
import { useHubStore } from '@/lib/store/hubStore';
import { useQuery } from '@tanstack/react-query';

export const useUserProfile = (email: string | null) => {
  return useQuery({
    queryKey: email ? userKeys.details(email) : ['users', 'null'],
    queryFn: async () => {
      if (!email) throw new Error('Email is required');

      const token = await getAuthToken();
      const { data: users } = await hubApi.listUsersByEmailHub(email, withAuthHeader(token));
      const normalizedEmail = email.toLowerCase();
      const user = users.find((entry) => entry.email.toLowerCase() === normalizedEmail) ?? users[0];

      if (!user) {
        throw new Error('User not found');
      }

      const {
        data: { sessions },
      } = await hubApi.getSessionsHub(
        user.id,
        undefined,
        undefined,
        undefined,
        withAuthHeader(token),
      );
      const { data: conversion } = await hubApi.getUserConversionHub(
        user.id,
        withAuthHeader(token),
      );

      if (user) {
        useHubStore.setState({
          searchUserData: { id: user.id, email: user.email },
        });
      }

      return { user, conversion: conversion, sessions };
    },
    enabled: !!email && email.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
